import React from 'react';
import { formatPrice } from '@dashboard/services/formatting';
import { useStatisticsContext } from '../Dashboard';
import { formatTimestamp, formatValue } from '../dates';
import { useStatistics } from '../queries';
import { StatHeader, StatMetric, StatTooltip, StatBody, StatChart } from './StatCard';

const formatUSD = amount => formatPrice({ amount, currency: 'USD' });

export default function MonthlyRecurringRevenue() {
  const { data, isLoading } = useStatistics('recurringRevenue');
  const { unit, range } = useStatisticsContext();

  const recurringRevenueData = data?.map(({ timestamp, value }) => ({
    timestamp: formatTimestamp(timestamp, unit, range),
    MRR: formatValue(timestamp, value),
  }));

  const maxValue = data && Math.max(...data?.map(({ value }) => value), 0);
  const minValue = data && Math.min(...data?.map(({ value }) => value), 0);

  const currentRecurringRevenue = data?.[data.length - 1]?.value;

  return (
    <div>
      <StatHeader>
        <StatMetric
          isLoading={isLoading}
          label="Monthly recurring revenue"
          tooltip={
            <StatTooltip>
              Monthly recurring revenue (MRR) is your estimated monthly revenue from all active and
              overdue subscriptions.
            </StatTooltip>
          }
          value={formatUSD(currentRecurringRevenue)}
        />
      </StatHeader>

      <StatBody>
        <StatChart
          isLoading={isLoading}
          data={recurringRevenueData}
          categories={['MRR']}
          maxValue={formatUSD(maxValue)}
          minValue={formatUSD(minValue)}
          valueFormatter={formatUSD}
        />
      </StatBody>
    </div>
  );
}
